export default {
	name: 'ShopMangment',
	data() {
		return {
			areaID: this.$store.state.user.areaID,
			search: '',
			clear: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			getData: {},
			shops: [],
			ShopID: this.$store.state.user.ShopID,

			editShopID: 0,
			ShopName: '',
			ShopAddress: '',
			editShopType: 2,
			BeginDate: '',
			EndDate: '',
			editShopState: 1,
			PayMoney: 0,
			IsSubject: 0,

			Edit: '',
			clear: {},

			ShopState: {},
			ShopType: {}

		}
	},
	created() {
		this.clear = () => {

			this.editShopID = 0;
			this.ShopName = '';
			this.ShopAddress = '';
			this.editShopType = 2;
			this.BeginDate = '';
			this.EndDate = '';
			this.editShopState = 1;
			this.PayMoney = 0;
		}
		this.ShopState = [{
				ID: 0,
				text: '正常运营'
			},
			{
				ID: 1,
				text: '停止运营'
			},
			{
				ID: -1,
				text: '停止(总部)'
			}
		];
		this.ShopType = [{
				ID: 0,
				text: '总部总店'
			},
			{
				ID: 1,
				text: '地区总店'
			},
			{
				ID: 2,
				text: '地区分店'
			}
		];
		this.getData = () => {

			this.$request.request({
				url: 'Shops/getShop',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					searchText: this.search,
					areaID: this.areaID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.shops = r.shops;
					this.count = r.count;
				} else {
					this.$uil.showMessage({
						text: r.message
					});
				}
			})
		}


	},

	methods: {
		editShop() {
			this.$request.request({
				url: 'Shops/editshopName',
				data: {
					areaID: this.areaID,
					ShopID: this.editShopID,
					ShopName: this.ShopName,
					ShopAddress: this.ShopAddress,
					ShopType: this.editShopType,
					beginData: this.BeginDate,
					endTime: this.EndDate,
					ShopState: this.editShopState,
					PayMoney: this.PayMoney,
					OperatorID: this.$store.state.user.UserID,
					IsSubject: this.IsSubject
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.getData();
					this.Edit = '';
					this.$store.dispatch('refresh');
				}
				this.$uil.showMessage({
					text: r.message
				});
			})


		},
		updateArea(i) {
			this.Edit = 'update';
			this.editShopID = i.ShopID;
			this.ShopName = i.ShopName;
			this.ShopAddress = i.ShopAddress;
			this.editShopType = i.ShopType;
			this.BeginDate = i.BeginDate;
			this.EndDate = i.EndDate;
			this.editShopState = i.ShopState;
			this.PayMoney = 0;
			this.IsSubject = 1;
		},

		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {

		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		checkShop() {
			if (!this.$uil.checkDate(this.EndDate) || !this.$uil.checkDate(this.BeginDate))
				return false;
			if (this.ShopName.trim().length == 0) return false;
			if (this.ShopAddress.trim().length == 0) return false;
			return true;



		}
	},
	filters: {
		ShopState(v) {
			switch (v) {
				case 0:
					return '正常营业';
				case 1:
					return '停止运营';
				case -1:
					return '总部停止';
			}
		},
		ShopType(v) {
			switch (v) {
				case 0:
					return '总部总店';
				case 1:
					return '地区总店';
				case 2:
					return '地区分店';
			}
		}
	},
	activated() {
		this.getData();
	}

}
